export enum CountryEnum {
  All,
  Brasil,
  Chile,
  Paraguay,
}
